import React from "react";
import { Box, Typography, Modal } from "@mui/material";

interface PropertyDetailsModalProps {
  open: boolean;
  onClose: () => void;
  property: string | null;
  description?: string;
  examples?: string[];
  related?: string[];
}

const PropertyDetailsModal: React.FC<PropertyDetailsModalProps> = ({
  open,
  onClose,
  property,
  description = "",
  examples = [],
  related = [],
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          backgroundColor: "#1b1a19",
          padding: 4,
          borderRadius: 2,
          maxWidth: "500px",
          margin: "auto",
          marginTop: "10%",
          outline: "none",
          color: "#fff",
        }}
      >
        <Typography variant="h6" sx={{ marginBottom: 2, fontWeight: 700 }}>
          {property || "Property Details"}
        </Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          {description}
        </Typography>
        {examples.length > 0 && (
          <>
            <Typography variant="body2" sx={{ marginBottom: 1 }}>
              <strong>Examples:</strong>
            </Typography>
            <ul>
              {examples.map((example, idx) => (
                <li key={idx}>{example}</li>
              ))}
            </ul>
          </>
        )}
        {related.length > 0 && (
          <>
            <Typography variant="body2" sx={{ marginBottom: 1 }}>
              <strong>Related:</strong>
            </Typography>
            <ul>
              {related.map((relatedItem, idx) => (
                <li key={idx}>{relatedItem}</li>
              ))}
            </ul>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default PropertyDetailsModal;
